import { Component, ComponentRef, effect, Type, ViewChild, ChangeDetectionStrategy } from '@angular/core';

import { Account } from '@app/common-codes/models/matwins-manager/Account.model';
import { IEntityMetaData } from '@app/common-codes/_models/IEntityMetaData';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { ManagerAccountDetailComponent } from '../account-detail/account-detail.component';
import { ListTableColumnComponent } from '@app/common-codes/components/list-components/list-table-column/list-table-column.component';
import { ListViewComponent } from '@app/common-codes/components/list-components/list-view/list-view.component';
import { TabComponentLoader } from '@app/common-codes/services/TabComponentLoader.service';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { AccountBaseListComponent } from '@app/components/matwins-tenant/account/account-list/account-list.component';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { LookupProfile } from '@app/common-codes/services/LookupService';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { AccountPermissionsDetailComponent } from '@app/components/matwins-tenant/account/account-detail/permissions-detail.component';
import { AccountBase } from '@app/common-codes/models/AccountBase.model';
import { ReactiveBadgeComponent } from '@app/common-codes/components/nested-components/reactive-badge/reactive-badge.component';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';

@Register(Account)
@Component({
  selector: 'app-manager-account-list',
  templateUrl: './account-list.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ListViewComponent,
    ListTableColumnComponent,
    ManagerAccountDetailComponent,
    TranslatePipe,
    AccountPermissionsDetailComponent,
    ReactiveBadgeComponent
  ]
})
export class ManagerAccountListComponent extends AccountBaseListComponent<Account> {
  override Skin: IStaticStylesConfig = MatwinsSkins.V1;
  override ComponentEntityClass = Account;
  override entityMetaData: IEntityMetaData = new Account().GetType();
  @ViewChild('accountDetail', { read: ManagerAccountDetailComponent }) accountDetail!: ManagerAccountDetailComponent;

  public static override get lookupProfiles(): LookupProfile[] {
    const lookupProfiles: LookupProfile[] = [
      {
        lookupName: "Role",
        lookupNamespace: "Matwins.Core.Model.MatwinsManager"
      },
      {
        lookupName: "i18nLanguage",
        lookupNamespace: "Matwins.Core.Model.MatwinsManager"
      }
    ];
    return lookupProfiles;
  }

  private tabComponentMap: Record<string, Type<any>> = {
    //'database-migrations': DataMigrationListComponent,
    //'database-logs': LogListComponent
  };

  constructor(private tabLoader: TabComponentLoader, alertModalService: AlertModalService) {
    super(alertModalService);

    let yyy = this;
  }

  override getdetailComponent(): GenetricDetailComponent<Account> | undefined {
    return this.accountDetail;
  }

  override openCreateModal() {
    var emptyEntity = this.getdetailComponent()?.getEmptyEntity();


    if (emptyEntity)
      this.selectedItem.set(emptyEntity);
    else
      this.selectedItem.set(null);
    this.isModalOpen.set(true);
  }

  override onItemUpdated(updatedItem: AccountBase) {
    super.onItemUpdated(updatedItem as Account);
  }

}
